import Icon from '../components/Icon.vue'

Icon.register({"first-aid":{"width":576,"height":512,"paths":[{"d":"M0 80V432C0 458.5 21.5 480 48 480H96V32H48C21.5 32 0 53.5 0 80zM128 480H448V32H128V480zM192 232C192 227.6 195.6 224 200 224H256V168C256 163.6 259.6 160 264 160H312C316.4 160 320 163.6 320 168V224H376C380.4 224 384 227.6 384 232V280C384 284.4 380.4 288 376 288H320V344C320 348.4 316.4 352 312 352H264C259.6 352 256 348.4 256 344V288H200C195.6 288 192 284.4 192 280V232zM528 32H480V480H528C554.5 480 576 458.5 576 432V80C576 53.5 554.5 32 528 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/first-aid.js
// module id = B1dS
// module chunks = 0